module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_9_Doyle.6c75850077960b035219d604935dd4d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_9_Doyle.png
// module id = 791
// module chunks = 0